import Constants, { fixProtocol } from '../../../constants/constants';
import { httpGet } from '../../../modules/api/axios_api';
import { configuration } from './configuration';

export const searchPlayers = async (parameters: { limit?: number; restorative?: boolean; query?: string }) => {
  const url = new URL(`${fixProtocol(Constants.BACKEND_URL)}/players/search-players`);
  const resultsLimit = parameters.limit || configuration.playersPerPage;

  url.searchParams.append('limit', `${resultsLimit}`);

  if (parameters.query && parameters.query !== '') {
    url.searchParams.append('query', parameters.query);
  }

  url.searchParams.append('restorative', parameters.restorative ? 'true' : 'false');

  return httpGet(url.toString())
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw new Error('Error getting patient list', error);
    });
};
